import { useEffect, useState } from "react";
import { Button, Col, Image, Row } from "react-bootstrap";
import { useNavigate, useLocation } from "react-router-dom";
import { useAlert } from "../../../../context/AlertContext";
import { formatInputDate } from "../../../../utils/Time";
import { getServiceRequest } from "../../../../commons/ServiceRequest";
import { MediaPreviewer } from "../../../../components/MediaUploader";
import { PDFPreviewFile } from "../../../../components/PDFFileHandler";
import { GooglePinIcon, PreviewIcon } from "../../../../data/iconImage";
import {
  filteredIndex,
  filteredItemInArray,
  findItemInArray
} from "../../../../utils/ManageArray";
import {
  formatCurrency,
  formatFileName,
  formatSplitKey,
  plusStringValue
} from "../../../../commons/FormatValue";

import {
  FloatingControlComponent,
  FormCheckComponent
} from "../../../../components/FormComponent";
import Table from "../../../../components/Table";
import ButtonLink from "../../../../components/ButtonLink";
import SearchFilter from "../../../../components/SearchFilter";
import CardDisplayComponent from "../../../../components/CardDisplayComponent";
import FileUploadsService from "../../../../services/fileupload.service";
import InformInstallJobsService from "../../../../services/informinstalljob.service";
import InformInstallItemBomsService from "../../../../services/informinstallitembom.service";

export default function SearchJob() {
  const navigate = useNavigate();
  const { showAlert } = useAlert();
  const { state } = useLocation();
  const [loading, setLoading] = useState(false);
  const [ShowPDF, setShowPDF] = useState(false);
  const [searchValue, setSearchValue] = useState(state?.searchValue || null);
  const [data, setData] = useState({ Install: [], ItemBoms: [], Asset: [] });
  const [fileMedia, setFileMedia] = useState({
    PDF: null,
    Image: [],
    Video: []
  });
  const searchInput = [
    {
      name: "Id",
      labelName: "Install_Doc_No",
      label: "หมายเลขแจ้งงานติดตั้ง",
      value: searchValue
    }
  ];
  const inputField = {
    Install: [
      {
        name: "Install_Doc_No",
        label: "หมายเลขแจ้งงานติดตั้ง",
        classNames: { col: "mb-3", label: "mb-1" }
      },
      {
        name: "Ref_Doc_No",
        label: "เลขที่อ้างอิง",
        classNames: { col: "mb-3", label: "mb-1" },
        size: "1_5"
      },
      {
        name: "Ref_Doc_Date",
        label: "วันที่อ้างอิง",
        classNames: { col: "mb-3", label: "mb-1" },
        size: "1_5",
        format: (value) => value && formatInputDate(value, "Local")?.date
      },
      {
        name: "JobType.Job_Type_Name",
        label: "ประเภทงาน",
        classNames: { col: "mb-3", label: "mb-1" },
        size: "1_5"
      },
      {
        name: "JobTypeSub.Job_Type_Sub_Name",
        label: "ประเภทงานย่อย",
        classNames: { col: "mb-3", label: "mb-1" },
        size: "1_5"
      },
      {
        name: "Install_Doc_Date",
        label: "วันที่แจ้งงาน",
        classNames: { col: "mb-3", label: "mb-1" },
        size: "1_75",
        format: (value) => value && formatInputDate(value, "Local")?.date
      },
      {
        name: "Install_Doc_Date",
        label: "",
        classNames: { col: "mb-3", label: "mb-1" },
        type: "time",
        size: "1_25",
        format: (value) => value && formatInputDate(value, "Local")?.time
      },
      {
        name: "Customer.Cus_Code",
        label: "รหัสลูกค้าหลัก",
        classNames: { col: "mb-3", label: "mb-1" }
      },
      {
        name: "Customer.Cus_Name",
        label: "ชื่อลูกค้า",
        classNames: { col: "mb-3", label: "mb-1" },
        size: 6
      },
      {
        name: "Job_Cus_Date",
        label: "วันที่นัดหมายลูกค้า",
        classNames: { col: "mb-3", label: "mb-1" },
        size: "1_75",
        format: (value) => value && formatInputDate(value, "Local")?.date
      },
      {
        name: "Job_Cus_Date",
        label: "",
        classNames: { col: "mb-3", label: "mb-1" },
        type: "time",
        size: "1_25",
        format: (value) => value && formatInputDate(value, "Local")?.time
      },
      {
        name: "Customer.Cus_Address",
        label: "ที่อยู่",
        plusString: [
          "Customer.Cus_Road",
          "Customer.Cus_District",
          "Customer.Cus_SubDistrict",
          "Customer.Cus_Province",
          "Customer.Cus_ZipCode"
        ],
        classNames: { col: "mb-3", label: "mb-1" },
        size: 9
      },
      {
        name: "Project_No",
        label: "หมายเลขโครงการ",
        classNames: { col: "mb-3", label: "mb-1" },
        size: "1_75"
      },
      {
        name: "Service_Call",
        label: "Call No.",
        classNames: { col: "mb-3", label: "mb-1" },
        size: "1_25"
      },
      {
        name: "BPCustomer.Cus_Code",
        label: "รหัสสาขา",
        classNames: { col: "mb-3", label: "mb-1" },
        size: 2
      },
      {
        name: "BPCustomer.Cus_NumBranch",
        label: "เลขที่สาขา",
        classNames: { col: "mb-3", label: "mb-1" },
        size: "1_25"
      },
      {
        name: "BPCustomer.Cus_Name",
        label: "ชื่อสาขา",
        classNames: { col: "mb-3", label: "mb-1" },
        size: null
      },
      {
        name: "Cus_Contract_Tel1",
        label: "เบอร์โทรผู้ติดต่อ 1",
        classNames: { col: "mb-3", label: "mb-1" }
      },
      {
        name: "Cus_Contract_Name1",
        label: "ผู้ติดต่อ 1",
        classNames: { col: "mb-3", label: "mb-1" }
      },
      {
        name: "BPCustomer.Cus_Address",
        label: "ที่อยู่สาขา",
        plusString: [
          "BPCustomer.Cus_Road",
          "BPCustomer.Cus_District",
          "BPCustomer.Cus_SubDistrict",
          "BPCustomer.Cus_Province",
          "BPCustomer.Cus_ZipCode"
        ],
        classNames: { col: "mb-3", label: "mb-1" },
        size: 6
      },
      {
        name: "Cus_Contract_Tel2",
        label: "เบอร์โทรผู้ติดต่อ 2",
        classNames: { col: "mb-3", label: "mb-1" }
      },
      {
        name: "Cus_Contract_Name2",
        label: "ผู้ติดต่อ 2",
        classNames: { col: "mb-3", label: "mb-1" }
      },
      {
        name: "Attach_File",
        label: "ไฟล์แนบ( PDF )",
        classNames: { col: "mb-3", label: "mb-1" },
        size: "8_33",
        format: (value) => formatFileName(value)
      },
      {
        name: "PreviewButton",
        classNames: { col: "mb-3 text-center" },
        type: "button",
        size: "0_67",
        disabled: !findItemInArray(data?.Install, "Id", searchValue)
          ?.Attach_File,
        icon: { src: PreviewIcon, alt: "Preview Icon" },
        onClick: () => setShowPDF(!ShowPDF)
      },
      {
        name: "Inform_Install_Status",
        label: "สถานะใบแจ้งงานติดตั้ง",
        classNames: { col: "mb-3", label: "mb-1" }
      },
      { name: "GoogleMap_Link", label: "Google Map", size: null },
      {
        name: "GoogleMapButton",
        classNames: { col: "w-auto" },
        type: "button",
        size: "0_67",
        disabled: !findItemInArray(data?.Install, "Id", searchValue)
          ?.GoogleMap_Link,
        icon: { src: GooglePinIcon, alt: "Google Pin Icon" },
        onClick: () =>
          window.open(
            findItemInArray(data?.Install, "Id", searchValue)?.GoogleMap_Link ||
              "https://www.google.com/maps",
            "_blank"
          )
      },
      { name: "Customer.Cus_ContactEmail", label: "Email" }
    ],
    Install_2: [
      {
        name: "Cus_Spec_Tex",
        label: "คำสั่งเพิ่มเติม (ลูกค้า)",
        classNames: { col: "mb-3", label: "mb-1" },
        size: 12
      }
    ],
    Radio: [
      { name: "PM_List", label: "มี PM" },
      { name: "PM_List", label: "ไม่มี PM" },
      { name: "PM_List", label: "รอสรุป" }
    ],
    Maintenance: [
      {
        name: "Contract_No",
        label: "เลขที่สัญญา",
        classNames: { col: "mb-3", label: "mb-1" },
        size: 4
      },
      {
        name: "CustContract.Contract_Start_Date",
        label: "วันที่เริ่มต้นสัญญา",
        classNames: { col: "mb-3", label: "mb-1" },
        size: 4,
        format: (value) => value && formatInputDate(value, "Local")?.date
      },
      {
        name: "CustContract.Contract_End_Date",
        label: "วันที่สิ้นสุดสัญญา",
        classNames: { col: "mb-3", label: "mb-1" },
        size: 4,
        format: (value) => value && formatInputDate(value, "Local")?.date
      },
      {
        name: "CustContract.CustContractItem.0.PM_Per_Year",
        label: "จำนวน PM/ปี",
        classNames: { col: "mb-3", label: "mb-1" },
        size: 4
      },
      {
        name: "Employee_Id",
        label: "ผู้แจ้ง",
        size: 4,
        plusString: ["Employee.Employee_Name", "Employee.Employee_Surname"],
        classNames: { col: "mb-3", label: "mb-1" }
      },
      {
        name: "Inform_Section",
        label: "แผนกที่แจ้ง",
        classNames: { col: "mb-3", label: "mb-1" },
        size: 4
      }
    ],
    Checkbox: [
      { name: "Job_List1", label: "สำรวจหน้างาน" },
      { name: "Job_List2", label: "งานรื้อถอน" },
      { name: "Job_List3", label: "ติดตั้ง" },
      { name: "Job_List4", label: "เทสระบบ" },
      { name: "Job_List5", label: "Training/ส่งมอบ" },
      { name: "Job_List6", label: "เก็บน้ำ" }
    ]
  };

  const columns = {
    Item: [
      {
        name: "ลำดับ",
        selector: (row) => row?.rowIndex,
        sortable: true,
        width: "110px"
      },
      {
        name: "รหัสสินค้า",
        selector: (row) => row?.Item?.Item_Code,
        sortable: true,
        minWidth: "280px"
      },
      {
        name: "รหัสทรัพย์สิน",
        selector: (row) => row?.Asset_Code,
        minWidth: "280px"
      },
      {
        name: "รายละเอียดสินค้า",
        selector: (row) => row?.Item?.Item_Name_TH,
        minWidth: "300px"
      },
      {
        name: "หมายเลขเครื่อง (Serial No.)",
        selector: (row) => row?.Item?.Item_PartNo,
        minWidth: "300px"
      },
      {
        name: "จำนวน",
        selector: (row) => row?.Item_Install_Qty,
        format: (row) => formatCurrency(row?.Item_Install_Qty || "")
      },
      { name: "หน่วย", selector: (row) => row?.Uom_Unit },
      {
        name: "สถานะทรัพย์สิน",
        selector: (row) => row?.Asset_Status
      }
    ],
    Asset: [
      {
        name: "ลำดับ",
        selector: (row) => row?.rowIndex,
        sortable: true,
        width: "110px"
      },
      {
        name: "รหัสสินค้า",
        selector: (row) => row?.Item?.Item_Code,
        sortable: true,
        minWidth: "280px"
      },
      {
        name: "รหัสทรัพย์สิน",
        selector: (row) => row?.AssetItem?.Asset_Code,
        minWidth: "280px"
      },
      {
        name: "รายละเอียดสินค้า",
        selector: (row) => row?.AssetItem?.Asset_Name,
        minWidth: "300px"
      },
      {
        name: "หมายเลขเครื่อง (Serial No.)",
        selector: (row) => row?.Item_PartNo,
        minWidth: "300px"
      },
      {
        name: "จำนวน",
        selector: (row) => row?.Item_Install_Qty,
        format: (row) => formatCurrency(row?.Item_Install_Qty || "")
      },
      { name: "หน่วย", selector: (row) => row?.AssetItem?.Uom_Unit },
      {
        name: "สถานะทรัพย์สิน",
        selector: (row) => row?.Asset_Status
      }
    ],
    ItemBom: [
      {
        name: "ลำดับ",
        selector: (row) => row?.rowIndex,
        sortable: true,
        width: "110px"
      },
      {
        name: "รหัสอุปกรณ์",
        selector: (row) => row?.ItemChild.Item_Code,
        sortable: true,
        minWidth: "280px"
      },
      {
        name: "รายละเอียดอุปกรณ์/อะไหล่",
        selector: (row) => row?.ItemChild.Item_Name_TH
      },
      { name: "จำนวน", selector: (row) => row?.Item_Qty },
      { name: "หน่วย", selector: (row) => row?.Uom_Unit },
      { name: "ราคา", selector: (row) => row?.Price_Per_Unit },
      { name: "ราคารวม", selector: (row) => row?.Amount },
      { name: "หน่วย", selector: (row) => row?.Amount_Unit }
    ],
    ServicePrice: [
      {
        name: "ลำดับ",
        selector: (row) => row?.rowIndex,
        sortable: true,
        width: "110px"
      },
      {
        name: "รายการค่าบริการ",
        selector: (row) => row?.Service_Des,
        sortable: true,
        minWidth: "280px"
      },
      {
        name: "ราคา",
        selector: (row) => row?.Service_Price,
        sortable: true,
        minWidth: "280px"
      },
      {
        name: "สกุลเงิน",
        selector: (row) => row?.Service_Unit,
        sortable: true,
        minWidth: "280px"
      },
      {
        name: "หมายเหตุ",
        selector: (row) => row?.Remark,
        sortable: true,
        minWidth: "280px"
      }
    ]
  };

  const InputShow = (field, dataField) => {
    const findData = findItemInArray(data?.[dataField], "Id", searchValue);
    return (
      <Row>
        {field.map(
          (
            {
              name,
              label,
              type,
              classNames,
              size,
              icon,
              format,
              plusString,
              disabled,
              onClick
            },
            idx
          ) => {
            let joinData = formatSplitKey(name, ".", findData);
            const result =
              (format && format(joinData)) ||
              (plusString && plusStringValue(plusString, " ", findData)) ||
              joinData ||
              "";

            return (
              <Col
                key={idx}
                sm={size === null ? null : size || 3}
                className={classNames?.col}
              >
                {type === "button" ? (
                  <Button
                    variant="outline-secondary"
                    className="mt-2 p-2 rounded-circle"
                    disabled={disabled}
                    onClick={onClick}
                    style={{ width: "45px" }}
                  >
                    <Image src={icon?.src} alt={icon?.alt} />
                  </Button>
                ) : (
                  <FloatingControlComponent
                    readOnly
                    name={name}
                    label={label}
                    className={classNames}
                    type={type || "text"}
                    value={result}
                  />
                )}
              </Col>
            );
          }
        )}
      </Row>
    );
  };

  const formCheck = ({ item, index, type, checked }) => {
    return (
      <Col key={`${type}-${index}`} sm={1} className="mb-3 w-auto">
        <FormCheckComponent
          readOnly
          id={item?.name}
          name="list"
          type={type}
          label={item?.label}
          className={{ check: "py-3 d-flex", input: "me-3", label: "w-auto" }}
          checked={!!checked}
          style={{ input: { cursor: "pointer" } }}
        />
      </Col>
    );
  };

  const handleSearch = (value) => {
    setSearchValue(value);
    if (!value) {
      setFileMedia({ Image: [], Video: [] });
      setData({ Install: [], ItemBoms: [] });
    }
  };

  const serviceRequest = (serviceMethod, nameObjectData) => {
    getServiceRequest({
      showAlert,
      setLoading,
      serviceRequest: serviceMethod,
      callback: (res) => setData((prev) => ({ ...prev, [nameObjectData]: res }))
    });
  };

  const getFileUpload = (destination, filename, type) => {
    getServiceRequest({
      showAlert,
      setLoading,
      serviceRequest: FileUploadsService.getFileUploads(destination, filename),
      callback: (response) => {
        const splitFileName = filename.split(".");
        const blobType =
          type === "PDF"
            ? "application/pdf"
            : `${type}/${splitFileName?.[splitFileName?.length - 1]}`;
        const blob = new Blob([response], { type: blobType });
        blob.name = filename;
        setFileMedia((prev) =>
          type === "PDF"
            ? { ...prev, [type]: { blob } }
            : { ...prev, [type]: [...prev[type], blob] }
        );
      }
    });
  };

  useEffect(() => {
    if (searchValue) {
      serviceRequest(
        InformInstallItemBomsService.getAllInformInstallItemBoms(),
        "ItemBoms"
      );
    }

    serviceRequest(
      InformInstallJobsService.getAllInformInstallJobs().then((dataInstall) => {
        if (searchValue) {
          // find Data InformOtherJob form searchValue
          const findedBP = findItemInArray(dataInstall, "Id", searchValue);
          // get PDF
          if (findedBP?.Attach_File) {
            getFileUpload("ใบแจ้งงานติดตั้ง/PDF", findedBP.Attach_File, "PDF");
          }
          // get Image and Video
          if (findedBP?.InformInstallJobFile?.length > 0) {
            setFileMedia((prev) => ({ ...prev, Image: [], Video: [] }));
            findedBP?.InformInstallJobFile.map(({ File_Path, File_Type }) =>
              getFileUpload(
                "ใบแจ้งงานติดตั้ง/Media",
                File_Path.split("/")?.[2],
                File_Type
              )
            );
          }
        }
        return dataInstall;
      }),
      "Install"
    );

    if (state?.name !== "data") {
      navigate("/installation_work/record", { state: { name: "data" } });
    }
  }, [searchValue]);

  return !ShowPDF ? (
    <>
      <CardDisplayComponent
        header={{
          title: { text: "ค้นหาหมายเลขใบแจ้งงาน", className: "text-center" }
        }}
        body={{
          element: (
            <SearchFilter
              data={data?.Install}
              inputField={searchInput}
              searchCallback={(search) => handleSearch(search?.[0]?.value)}
            />
          )
        }}
      />
      <CardDisplayComponent
        body={{ element: InputShow(inputField?.Install, "Install") }}
      />

      <CardDisplayComponent
        header={{ title: { text: "รายการสินค้า" } }}
        body={{
          element: (
            <Table
              data={
                findItemInArray(data?.Install, "Id", searchValue)
                  ?.InformInstallItem || []
              }
              column={
                ["IS04", "IS05", "IS06"].includes(
                  findItemInArray(data?.Install, "Id", searchValue)?.JobTypeSub
                    ?.Job_Type_Sub_Code
                )
                  ? columns?.Asset
                  : columns?.Item
              }
              pending={loading}
              pagination
            />
          )
        }}
      />

      <CardDisplayComponent
        header={{ title: { text: "รายการอะไหล่/อุปกรณ์" } }}
        body={{
          element: (
            <Table
              data={
                filteredItemInArray(
                  data?.ItemBoms,
                  "InformInstallItem.Job_Install_Id",
                  searchValue
                ) || []
              }
              column={columns?.ItemBom}
              pending={loading}
              pagination
            />
          )
        }}
      />

      <CardDisplayComponent
        header={{ title: { text: "รายละเอียดค่าบริการ" } }}
        body={{
          element: (
            <Table
              data={
                findItemInArray(data?.Install, "Id", searchValue)
                  ?.InstallServicePrice || []
              }
              column={columns?.ServicePrice}
              pending={loading}
              pagination
            />
          )
        }}
      />

      <CardDisplayComponent
        body={{ element: <>{InputShow(inputField.Install_2, "Install")}</> }}
      />

      <CardDisplayComponent
        header={{ title: { text: "รูปภาพประกอบ(ลูกค้า) ขนาดไม่เกิน 25 MB" } }}
        body={{
          className: "d-flex align-items-center overflow-x-auto",
          element: (
            <MediaPreviewer
              mediaType="Image"
              loading={loading}
              filePreview={filteredIndex(fileMedia?.Image, "name")}
            />
          )
        }}
      />

      <CardDisplayComponent
        header={{ title: { text: "วีดีโอประกอบ (ลูกค้า ) ขนาดไม่เกิน 25 MB" } }}
        body={{
          className: "d-flex align-items-center overflow-x-auto",
          element: (
            <MediaPreviewer
              mediaType="Video"
              loading={loading}
              filePreview={filteredIndex(fileMedia?.Video, "name")}
            />
          )
        }}
      />

      <CardDisplayComponent
        header={{ title: { text: "Preventive Maintenance" } }}
        body={{
          element: (
            <>
              <Row>
                {inputField.Radio.map((item, index) =>
                  formCheck({
                    item,
                    index,
                    type: "radio",
                    checked:
                      findItemInArray(data.Install, "Id", searchValue)?.[
                        item?.name
                      ] === item?.label
                  })
                )}
              </Row>
              {InputShow(inputField.Maintenance, "Install")}
            </>
          )
        }}
      />

      <CardDisplayComponent
        header={{ title: { text: "รายละเอียดการทำงาน" } }}
        body={{
          element: (
            <>
              <Row>
                {inputField.Checkbox.map((item, index) =>
                  formCheck({
                    item,
                    index,
                    type: "checkbox",
                    checked:
                      findItemInArray(data.Install, "Id", searchValue)?.[
                        item?.name
                      ] === item?.label
                  })
                )}
              </Row>
            </>
          )
        }}
      />

      <CardDisplayComponent
        footer={{
          className: "text-center",
          element: (
            <>
              <ButtonLink
                linkTo="preview"
                isDisabled={!searchValue}
                stateData={{
                  searchValue,
                  name: "data",
                  data: {
                    Install: findItemInArray(data.Install, "Id", searchValue),
                    ItemBoms: filteredItemInArray(
                      data?.ItemBoms,
                      "InformInstallItem.Job_Install_Id",
                      searchValue
                    )
                  }
                }}
                buttonName="แสดงและพิมพ์ใบแจ้งติดตั้ง"
                buttonColor="success"
                buttonClass="px-5 py-2 border-opacity-50 rounded-pill"
              />
            </>
          )
        }}
      />
    </>
  ) : (
    <CardDisplayComponent
      header={{
        title: {
          text: "แสดงตัวอย่างและพิมพ์ไฟล์แนบ",
          className: "text-dark text-center"
        }
      }}
      body={{ element: <PDFPreviewFile pdfFile={fileMedia?.PDF?.blob} /> }}
      footer={{
        className: "text-center border-top-0 bg-transparent",
        element: (
          <Button
            variant="outline-secondary"
            className="px-4 py-2 text-dark rounded-pill"
            onClick={() => setShowPDF(!ShowPDF)}
          >
            ย้อนกลับ
          </Button>
        )
      }}
    />
  );
}
